

















































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
// @ts-ignore-start
import { Editor, EditorContent, EditorMenuBar } from "tiptap";
// @ts-ignore-end
// @ts-ignore-start
import { Bold, Italic, Underline, Link, Image } from "tiptap-extensions";
// @ts-ignore-end
import Iframe from "./Iframe.js";
import LinkNewTab from "./linkNewTab";
import { parseEmbedLink } from "../../utils";

@Component({
  components: {
    EditorContent,
    EditorMenuBar
  }
})
export default class FeedbackEditor extends Vue {
  @Prop() private feedbackID!: string;
  @Prop() private content!: string;
  @Prop() private disabled!: boolean;
  @Prop() private isNewAdd!: boolean;
  @Prop() private isSelected!: boolean;

  private editor: any = null;
  private isDeleteText!: string;

  private created() {
    if (this.isNewAdd) {
      this.isDeleteText = "Cancel";
    } else {
      this.isDeleteText = "Delete";
    }
  }

  private mounted() {
    this.editor = new Editor({
      extensions: [
        new Bold(),
        new Italic(),
        new Underline(),
        new Image(),
        // custom extension
        new LinkNewTab(),
        new Iframe()
      ],
      editable: true,
      content: this.content
    });
    this.editor.setOptions({ editable: !this.disabled });
  }

  private beforeDestroy() {
    this.editor.destroy();
  }

  private showLinkPrompt(command: Function, commands: any) {
    const src = prompt("Enter the url of your link here");
    if (src !== null) {
      command({ href: src });
    }
  }

  private showImagePrompt(command: Function, commands: any) {
    const src = prompt("Enter the url of your image here");
    if (src !== null) {
      command({ src });
    }
  }

  private showEmbedPrompt(command: Function, commands: any) {
    const src = prompt("Enter the url of your youtube video");
    if (src !== null) {
      let parsedEmbedLink = parseEmbedLink(src);
      if (parsedEmbedLink) {
        command({ src: parsedEmbedLink });
      }
    }
  }

  private deleteComment() {
    this.$emit("deleteComment", this.feedbackID);
  }

  private addComment() {
    this.$emit("addComment", this.editor.getHTML(), this.feedbackID);
  }

  @Watch("disabled")
  private onDisabledChanged() {
    this.editor.setOptions({ editable: !this.disabled });
  }
}
